export const TRANSLATIONS_NO = {
  helloWorld: 'Hallo Verden',
  claim: 'PÅSTAND',
  showSources: 'vis kilder',
  hideSources: 'lukk',
  totalArticleScore: 'Artikkel Evaluering',
  source: 'KILDE',
};
